const locale = {
  DUPLICATE_OF: 'Duplikat av',
  DUPLICATED_BY: 'Duplicerad av',
  RELATED_TO: 'Relaterat till',
  SPLIT_TO: 'Dela till',
  SPLIT_FROM: 'Dela från',
  BLOCKED_BY: 'Blockerad av',
  BLOCKS: 'Block',
  MORE_THAN: 'Större än',
  LESS_THAN: 'Mindre än',
  OPEN: 'Öppna',
  IN_PROGRESS: 'Pågår',
  ON_HOLD: 'På vänteläge',
  COMPLETE: 'Komplett',
  'home.built': 'Byggd för att göra underhållshantering enklare',
  home_description:
    'När whiteboardtavlor och post-it-lappar är kaos, och du behöver en CMMS-programvara som är tillräckligt enkel för ditt team att faktiskt använda – prova {{shortBrandName}}',
  try_grash: 'Prova {{shortBrandName}}',
  login: 'Logga in',
  start_trial: 'Starta en gratis provperiod',
  'home.what': 'Vad',
  'home.you_will_have': 'Du kommer att ha',
  'home.you_will_have_description':
    'Bygg effektiva och tillförlitliga arbetsflöden som ger dig kontroll över underhållet. Generera, tilldela och spåra arbetsordrar. Kontrollera lagerhållning. Och få tillförlitliga automatiserade rapporter som förbättrar synligheten och skapar ansvarsskyldighet.',
  key_features: 'Viktiga funktioner',
  key_features_description:
    'Några av de funktioner som gör {{shortBrandName}} till ett av de bästa CMMS-systemen som finns tillgängliga idag',
  contribute: 'Medverka',
  work_orders: 'Arbetsordrar',
  request_system: 'System för arbetsförfrågningar',
  mobile_app: 'Mobilapp',
  asset_management: 'Kapitalförvaltning',
  preventive_maintenance: 'Förebyggande underhåll',
  parts_inventory: 'Reservdelslager',
  custom_dashboards: 'Anpassade instrumentpaneler',
  'work-orders.title': 'Hantera dina arbetsordrar som en chef',
  'work-orders.description.short': 'Visa och hantera alla dina uppgifter',
  'work-orders.descriptions.0':
    'Trött på massor av pappersarbete och borttappade arbetsordrar? Alla dessa borttappade saker påverkar direkt resultatet och ditt rykte.',
  'work-orders.descriptions.1':
    'Med {{shortBrandName}} kan du enkelt och snabbt organisera alla dina arbetsordrar, projektledningar och andra uppgifter i hela teamet i en centraliserad databas som kan nås var som helst på vilken enhet som helst.',
  'work-orders.checks.0':
    'Visa alla dina uppgifter inklusive arbetsuppgifter, projektledningar och arbetsförfrågningar',
  'work-orders.checks.1':
    'Ställ in uppgiftsprioritet så att rätt arbete blir gjort först.',
  'work-orders.checks.2':
    'Visa en kalender över aktuella och kommande uppgifter.',
  'work-orders.checks.3':
    'Visa arbetsuppgifter med viktig information som tillgångsinformation, förfallodatum, prioritet med mera.',
  'work-orders.checks.4':
    'Visa kritiska nyckeltal som faktiskt slutfört arbete, nedlagd tid och planerat kontra oplanerat arbete.',
  'work-requests.title':
    'Ett strömlinjeformat mobilt system för arbetsförfrågningar',
  'work-requests.descriptions.0':
    'Trött på att använda det gamla telefon- och e-postsystemet som resulterar i FÖRLORADE ärenden, ständiga dagliga avbrott och dubbelarbete?',
  'work-requests.descriptions.1':
    '{{shortBrandName}}s lösning för underhållshantering gör det möjligt för alla du godkänner att rapportera ett problem till din underhållsavdelning genom att helt enkelt skanna en QR-kod (streckkod) eller besöka en URL och skriva in sin begäran via sina mobila enheter.',
  'work-requests.checks.0': 'Förlora aldrig jobbet igen.',
  'work-requests.checks.1':
    'Minska tiden som läggs på att hantera arbetsförfrågningar med upp till 34 %.',
  'work-requests.checks.2':
    'Minska tiden det tar att kommunicera med beställare med upp till 41 % (samtal, e-post, sms).',
  'mobile-app.title': 'En mobil CMMS-app som stärker ditt underhållsteam',
  'mobile-app.descriptions.0':
    'Genom att använda vår Android-mobilapp upplever våra kunder bättre organisation, kommunikation, ansvarsskyldighet och produktivitet med upp till 30 % i hela sitt underhållsteam.',
  'mobile-app.descriptions.1':
    'Från sin handhållna enhet kan alla i ditt underhållsteam:',
  'mobile-app.checks.0':
    'Se deras tilldelade arbetsordrar och projektledningar.',
  'mobile-app.checks.1': 'Logga sina arbetsordrar på under 60 sekunder',
  'mobile-app.checks.2':
    'Få omedelbar kommunikation via push- och e-postmeddelanden.',
  'mobile-app.checks.3': 'Starta nya arbetsordrar ute i fält.',
  'mobile-app.checks.4':
    'Svara på och logga problem medan du faktiskt arbetar med problemet',
  'mobile-app.checks.5':
    'Sök efter information om viktig tillgång vid problemdiagnostik.',
  'eam.title': 'Företagstillgångshantering',
  'eam.description.short': 'Känn dina tillgångar',
  'eam.descriptions.0':
    'Frustrerad över att försöka organisera den kaotiska röran av företagets utrustning, undra om utrustningen har tagits om ordentligt, inte veta vad den kostar att underhålla och alla andra huvudvärk som följer med att hantera tillgångar?',
  'eam.descriptions.1':
    '{{brandName}}s modul för Enterprise Asset Management kan användas för allt mellan 10 och 1 000 000 tillgångar, vilket gör att du kan spåra exakt vad du vill, på det sätt du vill, i en lättanvänd och sökbar trädstruktur.',
  'eam.checks.0':
    'Känn till dina tillgångars tillstånd vid varje tidpunkt och vad de kostar dig',
  'eam.checks.1': 'Visa kompletta och detaljerade underhållsloggar.',
  'eam.checks.2': 'Spåra bara vad du vill med obegränsade anpassade fält',
  'eam.checks.3':
    'Organisera dina tillgångar i en tydlig hierarki mellan förälder och barn',
  'eam.checks.4':
    'Hitta information snabbt och enkelt med QR-koder (streckkoder)',
  'eam.checks.5': 'Ta emot tillgångsdata i realtid med sensoranslutning.',
  'pm.title': 'Ett effektivt förebyggande underhållsprogram',
  'pm.descriptions.0':
    'Sluta slösa värdefulla timmar på att manuellt distribuera PM-checklistor och följa upp med ditt team för att säkerställa att arbetet är klart.',
  'pm.descriptions.1':
    'Med {{shortBrandName}} kan du enkelt automatisera PM-schemaläggning så att rätt arbete automatiskt levereras vid rätt tidpunkt till rätt tekniker för rätt tillgång.',
  'pm.checks.0':
    'Automatisera PM-schemaläggning så att den är daglig, veckovis, månadsvis, årlig eller baserad på händelser eller mätaravläsningar.',
  'pm.checks.1':
    'Automatiska push- och e-postmeddelanden när ett PM skapas eller förfaller.',
  'pm.checks.2':
    'I vår lättanvända kalender kan du se alla lediga arbeten och kommande PM-scheman.',
  'pm.checks.3': 'Dra och släpp för att ändra förfallodatum.',
  'pm.checks.4':
    'När underhållsarbetet är klart loggas arbetet automatiskt i tillgångens underhållslogg.',
  'pm.checks.5': 'Kräver liten eller ingen utbildning att använda.',
  'part.title': 'Få kontroll över ditt reservdelslager',
  'part.description.short': 'Vet när dina delar kommer att ta slut',
  'part.descriptions.0':
    'Är du osäker på vilka delar du har i lager eller var de används? Vet du inte när dina delar kommer att ta slut eller om dina tekniker kommer att ha de delar som behövs för att utföra sina jobb?',
  'part.descriptions.1':
    'Vi utformade {{shortBrandName}}s reservdelshantering för att lösa dessa problem och mer:',
  'part.checks.0':
    'Få omedelbara push- och e-postmeddelanden när en dels kvantitet är låg. Håll rätt antal delar i lager genom att få omedelbara och automatiska push-/e-postmeddelanden när kvantiteten av en del understiger ett anpassat tröskelvärde.',
  'part.checks.1':
    'Tekniker vet direkt om delen finns i lager inifrån en arbetsorder. Om delen inte finns i lager kan du enkelt kontrollera andra platser för att se om den är tillgänglig.',
  'part.checks.2':
    'Automatisk spårning av reservdelar. När arbetsordrar eller projektledningar använder reservdelar uppdateras lagret automatiskt för att återspegla de använda reservdelarna.',
  'part.checks.3':
    'Ta reda på hur delen används. Visa delloggen för att se var delen används och av vem.',
  'part.checks.4':
    'Eliminera oanvända delar. Vet när en del har blivit gammal.',
  'part.checks.5':
    'Rapportering i realtid. Ta reda på vilka delar som används var och hur mycket de kostar dig.',
  'part.checks.6':
    'Optimera lagernivåerna. Se direkt prognoser för en del för att se hur många delar som kan komma att användas under nästa år.',
  'part.checks.7':
    'Streckkodssökning. Gör ditt lager enkelt att spåra och komma åt med anpassade QR-koder',
  'dashboard.title': 'Dina data, på ditt sätt med anpassade dashboards',
  'dashboard.descriptions.0':
    'Låt oss inse det, det första steget för att förbättra din verksamhet är att känna till det goda, det dåliga och det fula.',
  'dashboard.descriptions.1':
    'Med {{shortBrandName}}s anpassade dashboards kan du äntligen börja förstå det där skändliga "svarta hålet av underhåll" och börja omsätta databaserade planer i praktiken, vilket resulterar i minskade arbetskostnader, minskad driftstopp och mer.',
  'dashboard.descriptions.2':
    'Med {{shortBrandName}}s anpassade dashboards får du tillgång till …',
  'dashboard.checks.0': 'Vet var dina pengar spenderas och varför',
  'dashboard.checks.1': 'Vet vilken tillgång som kostar mest och varför',
  'dashboard.checks.2': 'Skapa dina egna anpassade KPI:er.',
  'dashboard.checks.3':
    'Visa rapporter som genereras och uppdateras automatiskt baserat på ditt mätvärde',
  'dashboard.checks.4':
    'Visa rapporter som enkelt kan delas via Excel-ark, PDF-filer eller inom {{shortBrandName}}',
  'dashboard.checks.5': 'Och så mycket mer ...',
  'home.smarter': 'Smartare',
  'home.work': 'Arbete',
  'home.smarter_description':
    '{{shortBrandName}} gör det otroligt enkelt för tekniker att arbeta effektivt genom att ge dem tillgång till de verktyg och data de behöver för att få jobbet gjort – allt direkt från deras handflata.',
  leading_maintenance:
    'Vi banar väg för en bättre framtid för underhåll och tillförlitlighet',
  premium_included: 'Premiumfunktioner ingår',
  no_credit_card: 'Inget kreditkort krävs',
  perfect_tool: 'Det perfekta verktyget för underhållsteam',
  start_trial_today: 'Starta din kostnadsfria provperiod idag',
  create_account: 'Skapa konto',
  signup_description: 'Fyll i fälten nedan för att registrera ett konto.',
  account_already: 'Har du redan ett konto?',
  signin_here: 'Logga in här',
  invalid_email: 'Den angivna e-postadressen ska vara en giltig e-postadress',
  required_email: 'E-postadressen är obligatorisk',
  required_firstName: 'Förnamnsfältet är obligatoriskt',
  required_lastName: 'Efternamnsfältet är obligatoriskt',
  required_company: 'Fältet för företagsnamn är obligatoriskt',
  required_employeesCount: 'Vänligen ange antalet anställda',
  invalid_phone: 'Telefonnumret är ogiltigt',
  required_password: 'Lösenordsfältet är obligatoriskt',
  required_terms: 'Du måste godkänna våra villkor',
  verify_email: 'Kontrollera din e-post för att aktivera ditt konto',
  registration_error: 'Registreringen misslyckades',
  first_name: 'Förnamn',
  last_name: 'Efternamn',
  email: 'E-postadress',
  phone: 'Telefon',
  password: 'Lösenord',
  companyName: 'Företagsnamn',
  employeesCount: 'Antal anställda',
  i_accept: 'Jag accepterar',
  terms_conditions: 'villkor',
  create_your_account: 'Skapa ditt konto',
  register: 'Register',
  login_description: 'Fyll i fälten nedan för att logga in på ditt konto.',
  no_account_yet: 'Har du inget konto än?',
  signup_here: 'Registrera dig här',
  wrong_credentials: 'Felaktiga inloggningsuppgifter angivna',
  lost_password: 'Glömt lösenord?',
  link_wo: 'Länka arbetsordrar',
  link_wo_description: 'Skapa relationer mellan arbetsordrar',
  required_relationType: 'Vänligen välj relationstyp.',
  required_wo: 'Fältet Arbetsorder är obligatoriskt.',
  this_wo: 'Denna arbetsorder',
  the_wo: 'Arbetsordern',
  link: 'Länk',
  cost_description: 'Kostnadsbeskrivning',
  assigned_to: 'Tilldelad till',
  category: 'Kategori',
  date: 'Datum',
  cost: 'Kosta',
  include_cost: 'Inkludera denna kostnad i den totala kostnaden',
  include_cost_description:
    'Detta kommer att lägga till kostnaden till den totala kostnaden som spenderats på arbetsordern.',
  required_cost_description: 'Kostnadsbeskrivning krävs',
  required_cost: 'Kostnad krävs',
  add_cost: 'Lägg till ytterligare kostnad',
  add_cost_description:
    'Fyll i fälten nedan för att skapa och lägga till ytterligare kostnad',
  add: 'Tillägga',
  hourly_rate: 'Timpris',
  include_time: 'Inkludera denna tid i den totala tiden',
  include_time_description:
    'Detta lägger till varaktigheten till den totala tiden som spenderats på arbetsordern.',
  work_started_at: 'Arbetet påbörjades kl.',
  duration: 'Varaktighet',
  hours: 'Timmar',
  minutes: 'Minuter',
  required_hours: 'Fältet för timmar är obligatoriskt',
  required_minutes: 'Minutfältet är obligatoriskt',
  add_time: 'Lägg till tid',
  add_time_description: 'Fyll i fälten nedan för att skapa och lägga till tid',
  feedback: 'Feed-back',
  feedback_description: 'Ge din feedback',
  required_feedback: 'Feedback krävs',
  signature: 'Signatur',
  required_signature: 'Bild krävs',
  close_wo: 'Stäng arbetsorder',
  close: 'Nära',
  task_update_success: 'Uppgiften har uppdaterats',
  task_update_failure: 'Uppgiften kunde inte uppdateras',
  notes_save_success: 'Anteckningarna har sparats',
  images_add_task_success: 'Bilderna har lagts till i uppgiften',
  images_add_task_failure: 'Något gick fel',
  images: 'Bilder',
  required_images: 'Vänligen ladda upp minst en bild',
  add_images: 'Lägg till bilder',
  tasks: 'Uppgifter',
  wo_archive_success: 'Arbetsordern har arkiverats',
  wo_archive_failure: 'Arbetsordern kunde inte arkiveras',
  wo_archive_confirm:
    'Är du säker på att du vill arkivera den här arbetsordern?',
  quantity_change_success: 'Kvantiteten har ändrats',
  quantity_change_failure: 'Kvantiteten kunde inte ändras',
  details: 'Detaljer',
  updates: 'Uppdateringar',
  id: 'ID',
  due_date: 'Två datum',
  location: 'Plats',
  asset: 'Tillgång',
  team: 'Team',
  created_at: 'Skapad datum',
  list_view: 'Listvy',
  calendar_view: 'Kalendervy',
  column_view: 'Kolumnvy',
  wo_create_success: 'Arbetsordern har skapats',
  wo_create_failure: 'Arbetsordern kunde inte skapas',
  changes_saved_success: 'Ändringarna har sparats',
  wo_update_failure: 'Arbetsordern kunde inte redigeras',
  wo_delete_success: 'Arbetsordern har raderats',
  wo_delete_failure: 'Arbetsordern kunde inte raderas',
  status: 'Status',
  title: 'Titel',
  priority: 'Prioritet',
  description: 'Beskrivning',
  worker: 'Arbetstagare',
  location_name: 'Platsnamn',
  location_address: 'Platsadress',
  asset_name: 'Tillgångsnamn',
  days_since_creation: 'Dagar sedan skapelsen',
  files: 'Filer',
  requested_by: 'Begärt av',
  completed_on: 'Avslutad den',
  updated_at: 'Uppdaterad kl.',
  work_order: 'Arbetsorder',
  timer_running: 'Timern körs',
  run_timer: 'Körtimer',
  approved_by: 'Godkänd av',
  created_by: 'Skapad av',
  completed_by: 'Slutförd av',
  time: 'Tid',
  save: 'Spara',
  customers: 'Entreprenörer',
  no_labor:
    'Inga arbetskostnader har lagts till ännu. De visas här när en användare loggar tid och har en timpris lagrad i {{shortBrandName}}.',
  not_assigned: 'Inte tilldelad',
  no_additional_cost: 'Inga extra kostnader har ännu lagts till',
  parts: 'Delar',
  links: 'Länkar',
  confirm_delete_file_wo:
    'Är du säker på att du vill ta bort den här filen från den här arbetsordern?',
  archive: 'Arkiv',
  labors: 'Arbeten',
  add_additional_cost: 'Lägg till ytterligare kostnad',
  additional_costs: 'Ytterligare kostnader',
  add_parts: 'Lägg till delar',
  'wo.title_description': 'Ange arbetsordertitel',
  image: 'Bild',
  estimated_duration: 'Beräknad varaktighet i timmar',
  primary_worker: 'Primärarbetare',
  additional_workers: 'Ytterligare arbetare',
  select_team: 'Välj lag',
  select_location: 'Välj plats',
  select_asset: 'Välj tillgång',
  select_tasks: 'Välj uppgifter',
  requires_signature: 'Kräver signatur',
  required_wo_title: 'Arbetsordertitel krävs',
  add_wo: 'Lägg till arbetsorder',
  add_wo_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny arbetsorder',
  edit_wo: 'Redigera arbetsorder',
  edit_wo_description: 'Fyll i fälten nedan för att uppdatera arbetsordern',
  'noRows.wo.message':
    'Arbetsordrar är uppgifter eller jobb som kan schemaläggas eller tilldelas någon',
  'noRows.wo.action': "Tryck på knappen '+' för att skapa en arbetsorder",
  to_delete: 'Radera',
  confirm_delete_wo: 'Är du säker på att du vill ta bort den här arbetsordern?',
  no_access_wo:
    'Du har inte åtkomst till arbetsordrar. Kontakta din administratör om du behöver åtkomst.',
  cancel: 'Avboka',
  select_parts: 'Välj delar',
  sets_of_parts: 'Delar i set',
  paused: 'Pausad',
  trigger_details: 'Utlösardetaljer',
  starts_on: 'Börjar på',
  ends_on: 'Slutar den',
  frequency: 'Frekvens',
  every_frequency_days: 'Var {{frequency}} dag',
  wo_details: 'Detaljer om arbetsordern',
  confirm_delete_file: 'Är du säker på att du vill ta bort den här filen?',
  wo_schedule_success: 'Arbetsuppdraget har schemalagts',
  wo_schedule_failure: 'Arbetsordern kunde inte schemaläggas',
  wo_trigger_edit_failure: 'Arbetsorderutlösaren kunde inte redigeras',
  wo_trigger_delete_success: 'Arbetsorderutlösaren har raderats',
  wo_trigger_delete_failure: 'Det gick inte att ta bort arbetsorderutlösaren',
  name: 'Namn',
  wo_title: 'Arbetsordertitel',
  next_wo: 'Nästa arbetsuppdrag',
  trigger_name: 'Utlösarnamn',
  enter_trigger_name: 'Ange utlösarens namn',
  frequency_description: 'Frekvens i dagar',
  wo_configuration: 'Konfiguration av arbetsorder',
  required_trigger_name: 'Triggernamn krävs',
  required_frequency: 'Triggerfrekvensen krävs',
  invalid_frequency: 'Frekvensen måste vara högre än 0',
  schedule_wo: 'Schemalägg arbetsorder',
  schedule_wo_description:
    'Fyll i fälten nedan för att schemalägga en arbetsuppgift',
  edit_wo_trigger: 'Redigera arbetsorderutlösare',
  edit_wo_trigger_description:
    'Fyll i fälten nedan för att redigera arbetsorderutlösaren',
  create_trigger: 'Skapa utlösare',
  'noRows.pm.message': 'Schemalägg arbetsordrar med anpassade triggers',
  'noRows.pm.action': "Tryck på '+'-knappen för att skapa en utlösare",
  confirm_delete_pm:
    'Är du säker på att du vill ta bort den här arbetsorderutlösaren?',
  no_access_pm:
    'Du har inte åtkomst till avsnittet Förebyggande underhåll. Kontakta din administratör om du behöver åtkomst.',
  enter_wo_title: 'Ange arbetsordertitel',
  status_report: 'Statusrapport',
  wo_analysis: 'Analys av arbetsorder',
  wo_aging: 'Åldrande av arbetsorder',
  time_and_cost: 'Tid och kostnad',
  assets: 'Tillgångar',
  reliability_dashboard: 'Tillförlitlighetsinstrumentpanel',
  total_maintenance_cost: 'Total underhållskostnad',
  useful_life: 'Nyttjandeperiod',
  requests: 'Förfrågningar',
  locations: 'Platser',
  parts_and_inventory: 'Delar/Inventarier',
  purchase_orders: 'Inköpsordrar',
  meters: 'Mätare',
  people_teams: 'Människor och team',
  people: 'Personer',
  teams: 'Lag',
  vendors_customers: 'Leverantörer och entreprenörer',
  vendors: 'Leverantörer',
  categories: 'Kategorier',
  settings: 'Inställningar',
  cancelled: 'Avbruten',
  reject: 'Avvisa',
  approve: 'Godkänna',
  request_create_success: 'Arbetsuppdraget har begärts',
  request_create_failure: 'Arbetsförfrågan kunde inte skapas',
  request_edit_failure: 'Begäran kunde inte redigeras',
  request_delete_success: 'Begäran har raderats',
  request_delete_failure: 'Begäran kunde inte raderas',
  rejected: 'Avvisad',
  approved: 'Godkänd',
  pending: 'I avvaktan på',
  required_request_name: 'Begäran om titel krävs',
  required_field: 'Detta fält är obligatoriskt',
  add_request: 'Lägg till begäran',
  add_request_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny förfrågan',
  edit_request: 'Redigera begäran',
  edit_request_description: 'Fyll i fälten nedan för att redigera begäran',
  'noRows.request.message': 'Hantera dina arbetsförfrågningar',
  'noRows.request.action':
    "Tryck på knappen '+' för att skapa en arbetsförfrågan",
  confirm_delete_request: 'Är du säker på att du vill ta bort den här begäran?',
  request: 'Begäran',
  request_details: 'Begär detaljer',
  none_priority: 'Ingen',
  low_priority: 'Låg',
  medium_priority: 'Medium',
  high_priority: 'Hög',
  downtimes: 'Stilleståndstider',
  confirm_delete_file_asset:
    'Är du säker på att du vill ta bort den här filen från den här tillgången?',
  actions: 'Åtgärder',
  show: 'Visa',
  model: 'Modell',
  serial_number: 'Serienummer',
  operational: 'Operativ',
  down: 'Ner',
  area: 'Område',
  barcode: 'Streckkod',
  placed_in_service: 'Satt i tjänst',
  warranty_expiration: 'Garantiutgång',
  asset_information: 'Information om tillgångar',
  more_informations: 'Mer information',
  confirm_delete_asset_downtime:
    'Är du säker på att du vill ta bort den här driftstoppstiden?',
  create_downtime_success: 'Nedtiden har lagts till',
  create_downtime_failure: 'Det gick inte att lägga till driftstoppet',
  edit_downtime_success: 'Stilleståndstiden har redigerats',
  started_on: 'Började den',
  required_startsOn: 'Startdatum är obligatoriskt',
  reading_create_success: 'Läsningen har lagts till',
  reading_create_failure: 'Läsningen kunde inte läggas till',
  reading: 'Läsning',
  added_by: 'Tillagd av',
  enter_meter_value: 'Ange mätarvärde',
  add_reading: 'Lägg till läsning',
  select_meter: 'Välj mätare',
  confirm_delete_part_asset:
    'Är du säker på att du vill ta bort den här delen från den här tillgången?',
  no_due_date: 'Inget förfallodatum',
  due_at_date: 'Två {{datum}}',
  no_primary_worker: 'Ingen primärarbetare',
  no_wo_linked_asset: 'Det finns ingen arbetsorder kopplad till denna tillgång',
  asset_remove_success: 'Resursen har raderats',
  asset_remove_failure: 'Det gick inte att ta bort tillgången',
  asset_name_description: 'Ange tillgångens namn',
  select_asset_location: 'Välj tillgångsplats',
  primary_user_description: 'Välj primär användare',
  teams_description: 'Välj lag',
  customers_description: 'Välj entreprenörer',
  vendors_description: 'Välj leverantörer',
  inServiceDate_description: 'Ibruktagningsdatum',
  warranty_expiration_date: 'Garantiens utgångsdatum',
  additional_information: 'Ytterligare information',
  structure: 'Strukturera',
  parent_asset: 'Modertillgång',
  asset_create_success: 'Tillgången har skapats',
  asset_create_failure: 'Det gick inte att skapa tillgången',
  additional_workers_description: 'Välj ytterligare arbetare',
  required_asset_name: 'Tillgångsnamn krävs',
  add_asset: 'Lägg till tillgång',
  add_asset_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny tillgång',
  create_asset: 'Skapa tillgång',
  hierarchy: 'Hierarki',
  add_downtime: 'Lägg till driftstopp',
  edit_downtime: 'Redigera driftstopp',
  remove_downtime: 'Ta bort driftstopp',
  edit: 'Redigera',
  edit_asset: 'Redigera tillgång',
  edit_asset_description:
    'Fyll i fälten nedan för att redigera den här tillgången',
  confirm_delete_asset:
    'Är du säker på att du vill ta bort den här tillgången?',
  loading_assets: 'Laddar resurser under {{name}} #{{id}}',
  no_content: 'Inget innehåll',
  no_result_criteria: 'Inget resultat matchar dina sökkriterier',
  map_view: 'Kartvy',
  location_create_success: 'Platsen har skapats',
  location_create_failure: 'Platsen kunde inte skapas',
  location_edit_failure: 'Platsen kunde inte redigeras',
  location_delete_success: 'Platsen har raderats',
  location_delete_failure: 'Platsen kunde inte raderas',
  enter_location_name: 'Ange platsnamn',
  address: 'Adress',
  parent_location: 'Förälderplats',
  select_workers: 'Välj arbetare',
  map_coordinates: 'Kartkoordinater',
  required_location_name: 'Platstitel krävs',
  required_location_address: 'Platsadress krävs',
  add_location: 'Lägg till plats',
  add_location_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny plats',
  edit_location: 'Redigera plats',
  edit_location_description: 'Fyll i fälten nedan för att uppdatera platsen',
  confirm_delete_location:
    'Är du säker på att du vill ta bort den här platsen?',
  floor_plans: 'Planritningar',
  floor_plan: 'Planritning',
  floor_plan_name_description: 'Planritningsnamn',
  'Floor plan area in m²': 'Planritningsyta i m²',
  upload_image: 'Ladda upp en bild',
  required_floor_plan_name: 'Planritningsnamn krävs',
  add_floor_plan: 'Lägg till ny planlösning',
  add_floor_plan_description:
    'Fyll i fälten nedan för att skapa en ny planritning',
  no_asset_in_location: 'Ingen tillgång på den här platsen',
  no_wo_in_location: 'Ingen arbetsorder på den här platsen',
  no_file_in_location: 'Inga filer bifogade till den här platsen',
  no_floor_plan_in_location: 'Ingen planritning på den här platsen',
  assigned_teams: 'Tilldelade lag',
  assigned_customers: 'Tilldelade entreprenörer',
  assigned_vendors: 'Tilldelade leverantörer',
  no_access_location:
    'Du har inte åtkomst till Platser. Kontakta din administratör om du behöver åtkomst.',
  no_access_vendors_customers:
    'Du har inte åtkomst till Leverantörer och Entreprenörer. Kontakta din administratör om du behöver åtkomst.',
  no_access_people_team:
    'Du har inte åtkomst till Personer och team. Kontakta din administratör om du behöver åtkomst.',
  no_access_analytics:
    'Du har inte åtkomst till Analytics. Kontakta din administratör om du behöver åtkomst.',
  no_access_assets:
    'Du har inte åtkomst till resurser. Kontakta din administratör om du behöver åtkomst.',
  no_access_categories:
    'Du har inte åtkomst till kategorier. Kontakta din administratör om du behöver åtkomst.',
  no_access_files:
    'Du har inte åtkomst till filer. Kontakta din administratör om du behöver åtkomst.',
  no_access_inventory:
    'Du har inte åtkomst till Inventariet. Kontakta din administratör om du behöver åtkomst.',
  no_access_meters:
    'Du har inte åtkomst till mätare. Kontakta din administratör om du behöver åtkomst.',
  no_access_purchase_orders:
    'Du kan inte skapa en inköpsorder. Kontakta din administratör om du ska ha åtkomst.',
  no_access_requests:
    'Du har inte åtkomst till förfrågningar. Kontakta din administratör om du behöver åtkomst.',
  no_access_settings:
    'Du har inte åtkomst till inställningarna. Kontakta din administratör om du behöver åtkomst.',
  no_access_page: 'Du har inte åtkomst till den här sidan',
  file: 'Fil',
  'noRows.location.message':
    'Platser låter dig hantera tillgångar och arbetare mer effektivt',
  'noRows.location.action': "Tryck på knappen '+' för att skapa en plats",
  card_view: 'Kortvy',
  set_create_success: 'Setet har skapats',
  set_create_failure: 'Det gick inte att skapa uppsättningen',
  set_edit_failure: 'Det gick inte att redigera uppsättningen',
  set_delete_success: 'Setet har raderats',
  set_delete_failure: 'Det gick inte att ta bort setet',
  total_cost: 'Totalkostnad',
  part: 'Del',
  enter_part_name: 'Ange delnamn',
  required_set_name: 'Ange namn krävs',
  add_set: 'Lägg till uppsättning',
  add_set_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny uppsättning',
  create_set: 'Skapa uppsättning',
  edit_set: 'Redigera uppsättning',
  edit_set_description: 'Fyll i fälten nedan för att redigera uppsättningen',
  confirm_delete_set:
    'Är du säker på att du vill ta bort den här uppsättningen?',
  part_create_success: 'Delen har skapats',
  part_create_failure: 'Delen kunde inte skapas',
  part_edit_failure: 'Delen kunde inte redigeras',
  part_delete_success: 'Delen har raderats',
  part_delete_failure: 'Delen kunde inte raderas',
  quantity: 'Kvantitet',
  open_wo: 'Öppna arbetsordrar',
  enter_part_category: 'Ange delkategori',
  enter_part_cost: 'Ange delkostnad',
  enter_part_quantity: 'Ange artikelkvantitet',
  minimum_quantity: 'Minsta kvantitet',
  enter_part_minimum_quantity: 'Ange minsta antal delar',
  non_stock: 'Ej i lager',
  enter_part_barcode: 'Ange delstreckkod',
  enter_part_area: 'Ange delområde',
  additional_part_details: 'Ytterligare deldetaljer',
  add_part: 'Lägg till del',
  add_part_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny del',
  create_part: 'Skapa del',
  update_part: 'Uppdatera del',
  update_part_description: 'Fyll i fälten nedan för att uppdatera delen',
  'noRows.part.message':
    'Delar kan kombineras till tillgångar eller användas var för sig',
  'noRows.part.action': "Tryck på '+'-knappen för att skapa en del",
  confirm_delete_part: 'Är du säker på att du vill ta bort den här delen?',
  part_details: 'Deldetaljer',
  area_details: 'Områdesdetaljer',
  assigned_people: 'Tilldelade personer',
  no_asset_related_part: 'Ingen tillgång relaterad till denna del',
  no_file_found: 'Ingen fil hittades',
  no_wo_found: 'Ingen arbetsorder hittades',
  workers: 'Arbetare',
  Parts_and_Inventory: 'Reservdelar och lager',
  po_edit_failure: 'Inköpsordern kunde inte redigeras',
  po_delete_success: 'Inköpsordern har raderats',
  po_delete_failure: 'Inköpsordern kunde inte raderas',
  number_of_items: 'Antal artiklar',
  total_quantity: 'Total kvantitet',
  shipping_to: 'Leverans till',
  shipping_address: 'Leveransadress',
  po_details: 'Detaljer om inköpsorder',
  enter_po_name: 'Ange inköpsordernamn',
  additional_details: 'Ytterligare detaljer',
  vendor: 'Försäljare',
  shipping_information: 'Leveransinformation',
  company_name: 'Företagsnamn',
  ship_to: 'Skicka till',
  city: 'Stad',
  state: 'Ange',
  zip_code: 'Postnummer',
  fax_number: 'Faxnummer',
  po_date: 'Inköpsorderdatum',
  notes: 'Anteckningar',
  add_notes: 'Lägg till anteckningar',
  requisitioner: 'Rekvisitor',
  terms: 'Villkor',
  shipping_method: 'Leveransmetod',
  required_name: 'Namnet är obligatoriskt',
  edit_po: 'Redigera inköpsorder',
  edit_po_description: 'Fyll i fälten nedan för att uppdatera inköpsordern',
  purchase_order: 'Inköpsorder',
  'noRows.po.message': 'Hantera dina inköpsordrar på ett och samma ställe',
  'noRows.po.action': "Tryck på knappen '+' för att skapa en inköpsorder.",
  confirm_delete_po: 'Är du säker på att du vill radera den här inköpsordern?',
  upgrade_po: 'Uppgradera för att skapa inköpsordrar',
  new_po: 'Ny inköpsorder',
  po_create_success: 'Inköpsordern har skapats',
  select_one_part: 'Välj minst 1 del',
  po_create_failure: 'Inköpsordern kunde inte skapas',
  approve_while_submitting: 'Godkänn vid inskickning',
  invalid_fax: 'Faxnumret är ogiltigt',
  submit: 'Överlämna',
  each_item_superior_zero: 'Varje artikelkvantitet måste vara större än 0',
  quantity_edit_success: 'Kvantiteten har ändrats',
  quantity_edit_failure: 'Kvantiteten kunde inte ändras',
  APPROVED: 'Godkänd',
  PENDING: 'I avvaktan på',
  REJECTED: 'Avvisad',
  when_reading_is: 'När mätaravläsningen är',
  greater_than: 'Större än',
  lower_than: 'Lägre än',
  value: 'Värde',
  required_value: 'Värdet är obligatoriskt',
  required_trigger_condition: 'Villkoret är obligatoriskt',
  wo_trigger_create_success: 'Arbetsorderutlösaren har skapats',
  wo_trigger_create_failure: 'Det gick inte att skapa arbetsorderutlösaren',
  add_wo_trigger: 'Lägg till arbetsorderutlösare',
  add_wo_trigger_description:
    'Fyll i fälten nedan för att skapa och lägga till en arbetsorderutlösare',
  wo_trigger_edit_success: 'Arbetsorderutlösaren har uppdaterats',
  meter_create_success: 'Mätaren har skapats',
  meter_create_failure: 'Mätaren kunde inte skapas',
  meter_edit_failure: 'Mätaren kunde inte redigeras',
  meter_delete_success: 'Mätaren har raderats',
  meter_delete_failure: 'Mätaren kunde inte raderas',
  next_reading_due: 'Nästa läsning',
  unit_of_measurement: 'Måttenhet',
  last_reading: 'Senaste läsning',
  enter_meter_name: 'Ange mätarnamn',
  unit: 'Enhet',
  update_frequency: 'Uppdateringsfrekvens',
  update_frequency_in_days: 'Uppdateringsfrekvens i dagar',
  required_meter_name: 'Mätarnamn krävs',
  required_meter_unit: 'Mätarenhet krävs',
  required_meter_update_frequency: 'Mätaruppdateringsfrekvens krävs',
  required_asset: 'Resurs krävs',
  add_meter: 'Lägg till mätare',
  add_meter_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny mätare',
  edit_meter: 'Redigera mätare',
  edit_meter_description: 'Fyll i fälten nedan för att redigera mätaren',
  confirm_delete_meter: 'Är du säker på att du vill ta bort den här mätaren?',
  upgrade_create_meter: 'Uppgradera för att skapa mätare',
  history: 'Historia',
  reading_frequency: 'Läsfrekvens',
  required_reading_value: 'Avläsningsvärde krävs',
  wo_triggers: 'Arbetsorderutlösare',
  add_trigger: 'Lägg till utlösare',
  meter_details: 'Mätardetaljer',
  'noRows.meter.message':
    'Mätaravläsningar ger dig möjlighet att övervaka tillgångar och utlösa nya arbetsordrar baserat på definierade villkor',
  'noRows.meter.action': "Tryck på '+'-knappen för att skapa en mätare",
  meter: 'Meter',
  drag_one_file: 'Dra en unik fil hit',
  drag_many_files: 'Dra och släpp filer här',
  drop_to_start: 'Släpp filerna för att börja uppladdningen',
  invalid_files_type: 'Du kan inte ladda upp dessa filtyper',
  you_have_uploaded: 'Du har laddat upp',
  upload: 'Ladda upp',
  Vendors_Customers: 'Leverantörer och entreprenörer',
  customer_create_success: 'Entreprenören har skapats',
  customer_create_failure: 'Entreprenören kunde inte skapas',
  customer_edit_failure: 'Entreprenören kunde inte redigeras',
  customer_delete_success: 'Entreprenören har raderats',
  customer_delete_failure: 'Entreprenören kunde inte raderas',
  customer_name: 'Entreprenörens namn',
  website: 'Webbplats',
  customer_type: 'Entreprenörstyp',
  customer_type_description: 't.ex. VVS, el',
  customer_description_description:
    'Beskriv syftet med denna entreprenör med några rader...',
  billing_information: 'Faktureringsinformation',
  address_line_2: 'Adressrad 2',
  billing_name: 'Faktureringsnamn',
  currency: 'Valuta',
  select_currency: 'Välj valuta',
  required_customer_name: 'Entreprenörens namn krävs',
  required_phone: 'Telefonnumret är obligatoriskt',
  invalid_website: 'Ogiltig webbplats',
  billing_address: 'Faktureringsadress',
  add_customer: 'Lägg till entreprenör',
  add_customer_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny entreprenör',
  'noRows.customer.message': 'Entreprenörer är externa arbetstagare',
  'noRows.customer.action': "Tryck på knappen '+' för att skapa en entreprenör",
  type: 'Typ',
  billing_currency: 'Faktureringsvaluta',
  go_back: 'Gå tillbaka',
  confirm_delete_customer:
    'Är du säker på att du vill ta bort den här entreprenören?',
  vendor_create_success: 'Leverantören har skapats',
  vendor_create_failure: 'Leverantören kunde inte skapas',
  vendor_edit_failure: 'Leverantören kunde inte redigeras',
  vendor_delete_success: 'Leverantören har raderats',
  vendor_delete_failure: 'Leverantören kunde inte raderas',
  required_company_name: 'Företagsnamn krävs',
  vendor_type: 'Leverantörstyp',
  contact_name: 'Kontaktnamn',
  add_vendor: 'Lägg till leverantör',
  add_vendor_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny leverantör',
  confirm_delete_vendor:
    'Är du säker på att du vill ta bort den här leverantören?',
  'noRows.vendor.message':
    'Leverantörer är organisationer som tillhandahåller tillgångar eller delar',
  'noRows.vendor.action': "Tryck på knappen '+' för att skapa en leverantör",
  vendor_type_description: 't.ex. VVS, el',
  role: 'Roll',
  edit_user: 'Redigera användare',
  edit_user_description: 'Fyll i fälten nedan för att redigera användaren',
  job_title: 'Jobbtitel',
  invite_users: 'Bjud in användare',
  bring_people_team: 'Ta med nya människor till teamet',
  add_20_users:
    "Du kan lägga till 20 användare åt gången genom att trycka på 'tabb' eller 'enter' efter varje e-postadress. Alla dubbletter och registrerade e-postadresser kommer att tas bort när de begärda användarna registreras.",
  enter_email: 'Ange e-postadress',
  users_invite_success: 'Användare har blivit inbjudna',
  users_invite_failure:
    'Användare kan inte bjudas in. Kontrollera ditt nuvarande antal prenumerationsmedlemmar.',
  please_type_emails: 'Vänligen skriv in e-postadresserna för att bjuda in',
  please_select_role: 'Vänligen välj en roll',
  invite: 'Bjuda',
  team_create_success: 'Teamet har skapats framgångsrikt',
  team_create_failure: 'Teamet kunde inte skapas',
  team_edit_failure: 'Teamet kunde inte redigeras',
  team_delete_success: 'Teamet har raderats',
  team_delete_failure: 'Teamet kunde inte raderas',
  team_name: 'Lagnamn',
  people_in_team: 'Människor i teamet',
  required_team_name: 'Lagnamn krävs',
  create_team: 'Skapa team',
  create_team_description: 'Du kan lägga till teammedlemmar härifrån',
  confirm_delete_team: 'Är du säker på att du vill ta bort det här laget?',
  overview: 'Översikt',
  activity: 'Aktivitet',
  wo_complete_last_14_days:
    'Arbetsordrar slutförda under de senaste 14 dagarna',
  no_wo_complete_last_14_days:
    'Du har inte slutfört några arbetsordrar under de senaste två veckorna',
  ADMIN_name: 'Administratör',
  ADMIN_description:
    'Administratören har fullständig åtkomst; inklusive att redigera, lägga till och ta bort arbetsordrar och förfrågningar',
  LIMITED_ADMIN_name: 'Begränsad administratör',
  LIMITED_ADMIN_description:
    'Begränsade administratörer har samma åtkomst som administratörer, förutom att de inte kan visa/redigera inställningar eller lägga till/redigera personer och team. De kan inte ta bort arbetsordrar, tillgångsplatser, mätare och inköpsordrar om de inte har skapat entreprenörer, kategorier och projektledningsutlösare.',
  TECHNICIAN_name: 'Tekniker',
  TECHNICIAN_description:
    'Tekniker kan skapa och stänga arbetsordrar, tillgångar och platser. Kan bara redigera och ta bort det de har skapat.',
  LIMITED_TECHNICIAN_name: 'Begränsad tekniker',
  LIMITED_TECHNICIAN_description:
    'Begränsade tekniker kan bara se arbetsordrar som tilldelats dem',
  VIEW_ONLY_name: 'Endast visning',
  VIEW_ONLY_description:
    'Användare som endast kan läsa har fullständig åtkomst men kan inte redigera något',
  REQUESTER_name: 'Begärande',
  REQUESTER_description:
    'Begärande kan bara skicka in arbetsförfrågningar och se deras status',
  select_user_role: 'Välj användarroll',
  'noRows.team.message':
    'Team hjälper dig att hantera specifika grupper av människor.',
  'noRows.team.action': "Tryck på '+'-knappen för att skapa ett lag.",
  user_details: 'Användaruppgifter',
  file_delete_success: 'Filen har raderats',
  file_delete_failure: 'Filen kunde inte raderas',
  uploaded_by: 'Uppladdad av',
  uploaded_on: 'Uppladdad den',
  rename: 'Döpa om',
  required_files: 'Vänligen ladda upp minst en fil',
  required_file_name: 'Ange ett filnamn',
  add_files: 'Lägg till filer',
  edit_file: 'Redigera fil',
  'noRows.file.message': 'Få alla filer på ett och samma ställe',
  'noRows.file.action': "Tryck på knappen '+' för att ladda upp en fil",
  upgrade_files:
    'Uppgradera för att använda filer i dina tillgångar, arbetsordrar, platser etc...',
  parts_consumption: 'Delförbrukning',
  requests_analysis: 'Begär analys',
  category_create_success: 'Kategorin har skapats',
  category_create_failure: 'Kategorin kunde inte skapas',
  category_edit_failure: 'Kategorin kunde inte redigeras',
  category_delete_success: 'Kategorin har raderats',
  category_delete_failure: 'Kategorin kunde inte raderas',
  timers: 'Timers',
  costs: 'Kostnader',
  add_category: 'Lägg till ny kategori',
  add_category_description:
    'Fyll i namnet för att skapa och lägga till en ny kategori',
  edit_category: 'Redigera kategori',
  edit_category_description: 'Fyll i namnet för att redigera kategorin',
  no_category_action:
    "Tryck på knappen '+' för att lägga till din första kategori.",
  confirm_delete_category:
    'Är du säker på att du vill ta bort den här kategorin?',
  no_category_message:
    'Det verkar som att du inte har några {{categoryName}}-kategorier ännu.',
  acquisition_cost: 'Anskaffningskostnad',
  general_settings: 'Allmänna inställningar',
  request_form_configuration: 'Konfiguration av begäran om formulär',
  roles: 'Roller',
  checklists: 'Checklistor',
  field_configuration_description:
    'Du kan markera fält som Valfria, Dolda eller Obligatoriska',
  optional: 'Frivillig',
  required: 'Nödvändig',
  hidden: 'Dold',
  creating_wo: 'Skapa en arbetsorder',
  completing_wo: 'Slutföra en arbetsorder',
  role_edit_failure: 'Rollen kunde inte redigeras',
  edit_role: 'Redigera roll',
  edit_role_description: 'Fyll i fälten nedan för att redigera rollen',
  external_id: 'Externt ID',
  permissions: 'Behörigheter',
  create_role_description:
    'Den här rollen kan göra allt en administratör kan göra i {{brandName}}, men du kan anpassa några viktiga behörigheter nedan.',
  create_and_edit: 'Skapa/Redigera',
  to_access: 'Tillträde',
  role_delete_success: 'Rollen har raderats',
  role_delete_failure: 'Rollen kunde inte tas bort',
  confirm_delete_role:
    'Är du säker på att du vill ta bort den här rollen permanent?',
  users: 'Användare',
  paid: 'Betald',
  free: 'Gratis',
  role_create_success: 'Rollen har skapats',
  role_create_failure: 'Rollen kunde inte skapas',
  roles_management: 'Rollhantering',
  roles_number: '{{count}} roller',
  create_role: 'Skapa roll',
  upgrade_role: 'Uppgradera för att skapa roll',
  add_role: 'Lägg till ny roll',
  add_role_description:
    'Fyll i fälten nedan för att skapa och lägga till en ny roll',
  parts_and_sets: 'Delar och delar',
  upgrade_role_edit: 'Uppgradera till redigeringsrollen',
  delete_role: 'Ta bort roll',
  upgrade_role_delete: 'Uppgradera för att ta bort rollen',
  create: 'Skapa',
  pm_trigger: 'Förebyggande underhållsutlösare',
  auto_assign_wo: 'Tilldela arbetsordrar automatiskt',
  auto_assign_wo_description:
    'Tilldela automatiskt nya arbetsordrar till den person som skapar dem',
  auto_assign_requests: 'Tilldela förfrågningar automatiskt',
  auto_assign_requests_description:
    'Tilldela automatiskt nya arbetsordrar till den person som godkänner begäran',
  disable_closed_wo_notification:
    'Inaktivera aviseringar om stängda arbetsordrar',
  disable_closed_wo_notification_description:
    'Inaktivera aviseringar när stängda arbetsordrar uppdateras',
  ask_feedback_wo_closed: 'Be om feedback när arbetsordern är stängd',
  ask_feedback_wo_closed_description:
    'Användare ombeds att ge feedback på utfört arbete',
  include_labor_in_total_cost:
    'Inkludera arbetskostnaden i den totala kostnaden',
  include_labor_in_total_cost_description:
    'Lägg till arbetskostnader till totalsumman när en användare loggar tid och har en timtaxa lagrad',
  enable_wo_updates_requesters:
    'Aktivera uppdateringar av arbetsordrar för beställare',
  enable_wo_updates_requesters_description:
    'Användare får uppdateringar för de arbetsordrar de begärt',
  language: 'Språk',
  date_format: 'Datumformat',
  business_type: 'Företagstyp',
  general_asset_management: 'Allmän kapitalförvaltning',
  physical_asset_management: 'Förvaltning av fysiska tillgångar',
  checklist_delete_success: 'Checklistan har raderats',
  checklist_delete_failure: 'Checklistan kunde inte raderas',
  create_checklist: 'Skapa checklista',
  confirm_delete_checklist:
    'Är du säker på att du vill ta bort den här checklistan?',
  upgrade_checklist: 'Uppgradera för att använda checklistor',
  upgrade_now: 'Uppgradera nu',
  total: 'Total',
  sub_task_status: 'Deluppgiftens status',
  text_field: 'Textfält',
  number_field: 'Nummerfält',
  inspection_check: 'Inspektionskontroll',
  multiple_choices: 'Flera val',
  meter_reading: 'Mätaravläsning',
  select_user: 'Välj användare',
  PASS: 'Passera',
  FLAG: 'Flagga',
  FAIL: 'Misslyckas',
  enter_task_name: 'Ange ett uppgiftsnamn',
  see_details: 'Se detaljer',
  concerned_asset: 'Berörd tillgång',
  me: 'Mig',
  remove_blank_tasks: 'Ta bort tomma uppgifter',
  remove_blank_options: 'Ta bort tomma alternativ',
  preview: 'Förhandsvisning',
  edit_checklist: 'Redigera checklista',
  add_tasks: 'Lägg till uppgifter',
  use_a_checklist: 'Använd en checklista',
  select_checklist: 'Välj checklista',
  save_checklist: 'Spara checklista',
  assign_tasks_description:
    'Tilldela anpassade uppgifter som tekniker ska fylla i',
  select_date: 'Välj datum',
  task: 'Uppgift',
  checklist: 'Checklista',
  upgrade_analytics: 'Uppgradera för att se Analytics',
  grouped_by_category: 'Grupperad efter kategori',
  downtime_by_asset: 'Driftstopp per tillgång',
  downtime_and_costs: 'Stilleståndstid och kostnader',
  downtime_and_costs_trends: 'Trender för driftstopp och kostnader',
  downtimes_trends: 'Trender för driftstopp',
  repair_time_by_asset: 'Reparationstid per tillgång',
  consumed_parts_costs: 'Kostnader för förbrukade delar',
  requests_by_priority: 'Förfrågningar efter prioritet',
  requests_trends: 'Förfrågningstrender',
  time_spent: 'Tid spenderad',
  grouped_by_completed_by: 'Grupperad efter Slutförd av',
  grouped_by_assigned_to: 'Grupperad efter Tilldelad till',
  grouped_by_priority: 'Grupperad efter prioritet',
  completion_comparison: 'Jämförelse av färdigställande',
  hours_worked: 'Arbetade timmar',
  work_remaining: 'Återstående arbete',
  wo_status: 'Status för arbetsorder',
  cost_trends: 'Kostnadstrender',
  cost_center: 'Analys av tillgångens livscykelkostnad',
  downtime_and_availability: 'Driftstopp och tillgänglighet',
  incomplete_wo: 'Ofullständiga arbetsordrar',
  the_numbers: 'Siffrorna',
  hours_and_cost_by_asset: 'Timmar och kostnad per tillgång',
  completion_comparison_description:
    'Jämförelse av olika typer av slutförda arbetsordrar.',
  wo_age_description:
    'Arbetsorderns ålder definieras som antalet dagar mellan skapandet av arbetsordern (eller arbetsförfrågan) och slutförandet.',
  rav_description:
    'Total kostnad som % av RAV är lika med (kostnad för arbetsordrar på tillgång / inköpspris) * 100. Branschstandard är ett målvärde på 3 % för detta mätvärde.',
  downtime_and_availability_description:
    'Tillgänglighet avser den procentandel som tillgångarna varit i drifttillstånd sedan de togs i bruk. Totala driftstopp avser antalet driftstoppshändelser som inträffade under det angivna datumintervallet.',
  total_cost_description:
    'Totalkostnaden inkluderar arbetskostnad, extra kostnad och delkostnad i en arbetsorder.',
  compliant_wo_description:
    'Kompatibla arbetsordrar definieras som arbetsordrar som slutfördes före förfallodatumet. Cykeltid avser antalet dagar tills en arbetsordrar slutfördes.',
  hours_worked_description:
    'Dessa timmar motsvarar arbetsordrar som har ett förfallodatum inom det intervall som anges i filtren.',
  work_remaining_description:
    'Det här diagrammet visar antalet ofullständiga arbetsordrar som förfaller inom det datumintervall som anges i filtren. De uppskattade timmarna motsvarar dessa individuella arbetsordrar.',
  total_downtime_in_hours: 'Total driftstopp (timmar)',
  downtime_events: 'Stilleståndshändelser',
  percent_downtime: '% Driftstopp',
  meantime_between_failures_in_hours: 'Medeltid mellan fel (timmar)',
  availability_percent: 'Tillgänglighetsprocent',
  mean_time_to_repair_in_hours: 'Genomsnittlig reparationstid (timmar)',
  average_age: 'Medelålder',
  count: 'Räkna',
  average_cost: 'Genomsnittlig kostnad',
  compliant: 'Kompatibel',
  average_cycle_time_in_days: 'Genomsnittlig cykeltid (dagar)',
  total_consumption_cost: 'Total förbrukningskostnad',
  parts_consumed: 'Förbrukade delar',
  total_cost_as_pct_rav: 'Totalkostnad som andel av RAV',
  approved_requests: 'Godkända förfrågningar',
  pending_requests: 'Väntande förfrågningar',
  cancelled_requests: 'Avbrutna förfrågningar',
  average_cycle_time: 'Genomsnittlig cykeltid',
  compliance_rate: 'Efterlevnadsgrad',
  complete: 'Komplett',
  reactive: 'Reaktiv',
  recurring: 'Återkommande',
  part_costs: 'Delkostnader',
  labor_costs: 'Arbetskraftskostnad',
  total_time_spent_in_hours: 'Total tid (timmar)',
  estimated_hours: 'Beräknade timmar',
  total_purchase_price: 'Totalt köpeskilling',
  you_have: 'Du har',
  new_messages: 'nya meddelanden',
  company: 'Företag',
  change_cover: 'Byt omslag',
  required_address: 'Adressfältet är obligatoriskt',
  company_details: 'Företagsuppgifter',
  company_details_description:
    'Hantera information relaterad till ditt företag',
  learn_more: 'Läs mer',
  profile: 'Profil',
  email_notifications: 'E-postmeddelanden',
  email_updates_wo: 'E-postuppdateringar för arbetsordrar och meddelanden',
  email_updates_requests: 'E-postuppdateringar för begärda arbetsordrar',
  po_emails: 'E-postmeddelanden för inköpsorder',
  required_job_title: 'Fältet för jobbtitel är obligatoriskt',
  required_old_password: 'Vänligen ange det nuvarande lösenordet.',
  invalid_password: 'Lösenordet är för kort – bör vara minst 8 tecken långt.',
  required_new_password: 'Inget lösenord tillhandahålls.',
  passwords_must_match: 'Lösenorden måste matcha',
  password_change_success: 'Lösenordet har ändrats',
  wrong_password: 'Fel lösenord angivet',
  current_password: 'Nuvarande lösenord',
  new_password: 'Nytt lösenord',
  confirm_password: 'Bekräfta lösenord',
  personal_details: 'Personliga uppgifter',
  personal_details_description:
    'Hantera information relaterad till dina personuppgifter',
  change_password: 'Ändra lösenord',
  notification_settings: 'Aviseringsinställningar',
  notification_settings_description:
    'Hantera information relaterade till dina aviseringar',
  recent_activity: 'Senaste aktivitet',
  created: 'Skapad',
  completed: 'Avslutad',
  my_account: 'Mitt konto',
  my_company: 'Mitt företag',
  you_are_using_plan:
    'Du använder för närvarande planen {{planName}}. Den upphör att gälla den {{expiration}}. Uppgradera nu för att få tillgång till fler funktioner.',
  upgrade_plan: 'Uppgraderingsplan',
  plans: 'Planer',
  monthly: 'Månatlig',
  annually: 'Årligen',
  subscription_change_success: 'Prenumerationen har ändrats',
  invalid_credit_card: 'Kreditkortsnumret är ogiltigt',
  required_credit_card: 'Kortfältet är obligatoriskt',
  invalid_expiration_month: 'Utgångsmånaden är ogiltig',
  required_expiration_month: 'Utgångsmånaden är obligatorisk',
  invalid_expiration_year: 'Utgångsåret är ogiltigt',
  required_expiration_year: 'Utgångsår krävs',
  invalid_cvv: 'CVV är ogiltigt',
  required_cvv: 'CVV krävs',
  required_cardholder_name: 'Kortinnehavarens namn är obligatoriskt',
  card: 'Kort',
  expiration_month: 'Utgångsmånad',
  expiration_year: 'Utgångsår',
  cardholder_name: 'Kortinnehavarens namn',
  seats: 'Sittplatser',
  cost_per_seat: 'Kostnad per plats',
  your_payment_secure: 'Dina betalningsuppgifter är krypterade och säkra.',
  plan: 'Planera',
  current_plan: 'Nuvarande plan',
  number_users_who_will_use_grash:
    'Antal användare som kommer att använda {{shortBrandName}}',
  admin_role: 'Administration',
  technical_role: 'Teknisk',
  limited_technical_role: 'Begränsad teknisk',
  requester_role: 'Begärande',
  view_only_role: 'Endast skrivskyddad',
  how_will_you_be_billed: 'Hur vill du bli fakturerad?',
  which_plan_fits_you: 'Vilken plan passar dig bäst?',
  per_user_month: 'per användare/månad',
  per_user_year: 'per användare/år',
  you_will_be_charged: 'Du kommer att debiteras',
  proceed_to_payment: 'Gå vidare till betalning',
  pay_only_for_roles:
    'Betala endast för <strong>administratörer</strong> , <strong>tekniska användare</strong> och <strong>begränsade tekniska</strong> användare, och använd obegränsat <strong>antal förfrågningar</strong> och <strong>endast visning</strong> gratis.',
  checkout_our: 'Kolla in vår',
  pricing_page: 'Prissida',
  for_more_details: 'för mer information',
  users_count_display: '{{count}} användare',
  monthly_adverb: 'månatlig',
  yearly_adverb: 'årlig',
  features: 'Drag',
  checkout: 'Kassa',
  checkout_description: 'Fyll i fälten nedan',
  per_month: 'per månad',
  per_year: 'varje år',
  recover_password_description:
    'Ange e-postadressen som användes för registrering för att återställa ditt lösenord.',
  send_me_new_password: 'Skicka mig ett nytt lösenord',
  want_to_sign_in_again: 'Vill du försöka logga in igen?',
  check_mails_for_instructions:
    'Kontrollera din e-post för ytterligare instruktioner',
  pdf_report: 'PDF-rapport',
  HIGH: 'Hög',
  MEDIUM: 'Medium',
  LOW: 'Låg',
  NONE: 'Ingen',
  import: 'Importera',
  start_import_process: 'Starta importprocessen',
  import_data: 'Importera data',
  set_header: 'Ange rubrik',
  match_columns: 'Matcha kolumner',
  review: 'Recension',
  done: 'Gjort',
  no_match_yet: 'Ingen matchning ännu',
  select: 'Välja...',
  matched_to_field: 'Matchade med {{field}}',
  next: 'Nästa',
  not_enough_rows: 'Inte tillräckligt med rader i filen',
  there_are_duplicates: 'Det finns dubbletter: {{duplicates}}',
  assigned_by: 'Tilldelad av',
  percent_rows_have_value: '{{percent}}% av raderna har värde',
  match_at_least_column: 'Matcha minst en kolumn',
  to_import: 'Importera',
  required_match: '{{field}}-matchning krävs',
  archived: 'Arkiverad',
  import_wo_success:
    '{{created}} Arbetsordrar har skapats och {{update}} har uppdaterats',
  to_export: 'Exportera',
  filters: 'Filter',
  more_filters: 'Fler filter',
  customer: 'Entreprenör',
  to: 'till',
  dates: 'Datum',
  start: 'Start',
  end: 'Avsluta',
  longitude: 'Longitud',
  latitude: 'Latitud',
  ALL: 'Alla',
  REACTIVE: 'Reaktiv',
  REPEATING: 'Förebyggande',
  import_location_success:
    '{{created}} Platser har skapats och {{updated}} har uppdaterats',
  import_part_success: 'Delar har skapats och uppdaterats.',
  import_meter_success:
    '{{created}} Mätare har skapats och {{updated}} har uppdaterats',
  import_asset_success:
    '{{created}} Tillgångar har skapats och {{updated}} har uppdaterats',
  wo_calendar: 'Kalender för arbetsordrar',
  month: 'Månad',
  week: 'Vecka',
  day: 'Dag',
  agenda: 'Dagordning',
  previous: 'Tidigare',
  today: 'I dag',
  to_filter: 'Filtrera',
  'noRows.asset.message':
    'Tillgångar är resurser som ditt företag kan ingripa i',
  'noRows.asset.action': "Tryck på knappen '+' för att skapa en ny tillgång.",
  reset_filters: 'Återställ filter',
  toggle_menu: 'Växla meny',
  no_results: 'Inga resultat hittades',
  an_error_occured: 'Ett fel uppstod.',
  density: 'Densitet',
  compact: 'Kompakt',
  standard: 'Standard',
  comfortable: 'Bekväm',
  columns: 'Kolumner',
  select_columns: 'Välj kolumner',
  show_filters: 'Visa filter',
  hide_filters: 'Dölj filter',
  search_placeholder: 'Söka…',
  search: 'Söka',
  clear: 'Rensa',
  download_as_csv: 'Ladda ner som CSV',
  print: 'Skriva ut',
  download_as_excel: 'Ladda ner som Excel',
  find_column: 'Hitta kolumnen',
  column_title: 'Kolumnrubrik',
  reorder_column: 'Ordna om kolumnen',
  show_all: 'Visa alla',
  hide_all: 'Dölj alla',
  add_filter: 'Lägg till filter',
  logic_operator: 'Logikoperator',
  operator: 'Operatör',
  and: 'Och',
  or: 'Eller',
  filter_value: 'Filtervärde',
  contains: 'innehåller',
  equals: 'lika med',
  starts_with: 'börjar med',
  ends_with: 'slutar med',
  is: 'är',
  is_not: 'är inte',
  is_after: 'är efter',
  is_on_or_after: 'är på eller efter',
  is_before: 'är före',
  is_on_or_before: 'är på eller före',
  is_empty: 'är tom',
  is_not_empty: 'är inte tom',
  is_any_of: 'är någon av',
  any: 'några',
  true_text: 'sann',
  false_text: 'falsk',
  menu: 'Meny',
  show_columns: 'Visa kolumner',
  hide: 'Dölja',
  unsort: 'Avsortera',
  sort_by_ASC: 'Sortera efter ASC',
  sort_by_DESC: 'Sortera efter DESC',
  sort: 'Sortera',
  total_rows: 'Totalt antal rader:',
  yes: 'Ja',
  no: 'Inga',
  more: 'Mer',
  to_group: 'Grupp',
  see_children: 'se barn',
  hide_children: 'dölja barn',
  expand: 'Expandera',
  collapse: 'Kollapsa',
  detail_panel_toggle: 'Växla mellan detaljerade paneler',
  cancel_subscription: 'Avsluta prenumeration',
  resume_subscription: 'Återuppta prenumerationen',
  confirm_cancel_subscription:
    'Är du säker på att du vill avsluta prenumerationen?',
  workflows: 'Arbetsflöden',
  create_workflow: 'Skapa arbetsflöde',
  if: 'Om',
  and_optional: 'Och (valfritt)',
  then: 'Sedan',
  workflow_description:
    'Skapa anpassade arbetsflöden lika enkelt som Om, Och, Sedan. Spara tid och tilldela enkelt dina arbetsordrar automatiskt via arbetsflöden för att anpassa {{shortBrandName}} efter hur ditt team arbetar.\n\nAlla abonnemang kan skapa upp till ett anpassat arbetsflöde. För att lägga till ytterligare arbetsflöden, uppgradera till vårt företagsabonnemang.',
  CREATE_PURCHASE_ORDER: 'Skapa en inköpsorder',
  PART_IS: 'Delen är',
  QUANTITY_INFERIOR: 'Mängden är sämre än',
  ASSIGN_VENDOR: 'Tilldela leverantören',
  ASSIGN_CATEGORY: 'Tilldela kategorin',
  APPROVE: 'Godkänna',
  REJECT: 'Avvisa',
  SEND_REMINDER_EMAIL: 'Skicka påminnelsemejl',
  VENDOR_IS: 'Säljaren är',
  CATEGORY_IS: 'Kategorin är',
  STATUS_IS: 'Statusen är',
  DUE_DATE_BETWEEN: 'Förfallodagen är mellan',
  DUE_DATE_AFTER: 'Förfallodagen är efter',
  ASSIGN_PRIORITY: 'Tilldela prioriteten',
  ASSIGN_ASSET: 'Tilldela tillgången',
  ASSIGN_LOCATION: 'Tilldela platsen',
  ASSIGN_USER: 'Tilldela användaren',
  ASSIGN_TEAM: 'Tilldela teamet',
  ADD_CHECKLIST: 'Lägg till checklista',
  PRIORITY_IS: 'Prioriteten är',
  ASSET_IS: 'Tillgången är',
  LOCATION_IS: 'Platsen är',
  USER_IS: 'Användaren är',
  TEAM_IS: 'Laget är',
  CREATED_AT_BETWEEN: 'Skapas mellan',
  TITLE_CONTAINS: 'Titeln innehåller',
  CREATE_REQUEST: 'Skapa en förfrågan',
  CREATE_WORK_ORDER: 'Skapa en arbetsorder',
  SET_ASSET_STATUS: 'Ange tillgångsstatus',
  NAME_IS: 'Namnet är',
  NAME_CONTAINS: 'Namnet innehåller',
  VALUE_IS: 'Värdet är',
  VALUE_CONTAINS: 'Värdet innehåller',
  NUMBER_VALUE_SUPERIOR: 'Värdet är överlägset',
  NUMBER_VALUE_INFERIOR: 'Värdet är sämre än',
  WORK_ORDER_CREATED: 'En arbetsorder skapas',
  WORK_ORDER_CLOSED: 'En arbetsorder är stängd',
  WORK_ORDER_ARCHIVED: 'En arbetsorder arkiveras',
  REQUEST_CREATED: 'En begäran skapas',
  REQUEST_APPROVED: 'En begäran är godkänd',
  REQUEST_REJECTED: 'En begäran avvisas',
  PURCHASE_ORDER_CREATED: 'En inköpsorder skapas',
  PURCHASE_ORDER_UPDATED: 'En inköpsorder uppdateras',
  TASK_UPDATED: 'En uppgift uppdateras',
  PART_UPDATED: 'En del är uppdaterad',
  add_condition: 'Lägg till villkor',
  workflow_creation_success: 'Arbetsflödet har skapats',
  workflow_creation_failure: 'Skapandet av arbetsflödet misslyckades',
  action_value_missing: 'Åtgärdsvärdet saknas',
  condition_value_missing: 'Ett villkorsvärde saknas',
  workflow_edit_success: 'Arbetsflödet har uppdaterats',
  workflow_edit_failure: 'Arbetsflödet kunde inte redigeras',
  workflow_delete_success: 'Arbetsflödet har raderats',
  workflow_delete_failure: 'Arbetsflödet kunde inte tas bort',
  confirm_delete_workflow:
    'Är du säker på att du vill ta bort det här arbetsflödet',
  click_here: 'Klicka här',
  verify_email_title: 'Verifiera e-postadress',
  verify_email_description:
    'Ett verifieringsmejl har skickats till dig. Kolla skräpposten om du inte ser det i din inkorg.',
  upgrade: 'Uppgradera',
  downgrade: 'Nedvärdera',
  upgrade_description:
    'Du har precis uppgraderat din prenumeration. Du måste aktivera de inaktiverade användare som kan komma att använda {{shortBrandName}}. Du kan bara göra detta en gång för den aktuella prenumerationen. Välj noggrant.',
  enable_users: 'Aktivera användare',
  max_users_description: 'Du kan aktivera upp till {{maxUsers}} användare',
  downgrade_description:
    'Du har just nedgraderat din prenumeration. Du måste inaktivera vissa användare för att kunna fortsätta. Du kan bara göra detta en gång för den aktuella prenumerationen. Välj noggrant.',
  disable_users: 'Inaktivera användare',
  min_users_description: 'Du måste inaktivera minst {{minUsers}} användare',
  downgrade_description_no_owner:
    'Ditt företag har just nedgraderat sin prenumerationsplan. Företagsägaren måste inaktivera vissa användare innan du kan fortsätta.',
  past_due: 'Förfallna',
  due_date_delay: 'Försening av förfallodatum',
  due_date_delay_description: 'Försening av förfallodatum i dagar',
  days_count: '{{dagar}} dagar',
  trigger_configuration: 'Triggerkonfiguration',
  WORK_ORDER_feature: 'Arbetsordrar',
  REQUEST_feature: 'Arbetsförfrågningar',
  PART_feature: 'Delhantering',
  MOBILE_APP_feature: 'Mobilapp',
  WORK_ORDER_HISTORY_feature: 'Arbetsordrar Historik',
  PREVENTIVE_MAINTENANCE_feature: 'Förebyggande underhåll',
  CHECKLIST_feature: 'Checklistor',
  FILE_feature: 'Filuppladdningar',
  PURCHASE_ORDER_feature: 'Inköpsordrar',
  METER_feature: 'Mätaravläsningar',
  REQUEST_CONFIGURATION_feature: 'Konfiguration av begärandeformulär',
  ADDITIONAL_TIME_feature: 'Avancerad tidsspårning',
  ADDITIONAL_COST_feature: 'Avancerad kostnadsspårning',
  ANALYTICS_feature: 'Analys och rapportering',
  REQUEST_PORTAL_feature: 'Begäransportal',
  SIGNATURE_feature: 'Signaturer',
  ROLE_feature: 'Anpassade roller',
  WORKFLOW_feature: 'Automatisering av arbetsflöden',
  API_ACCESS_feature: 'API-åtkomst',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: 'Lägg till nytt alternativ',
  edit_company: 'Redigera företag',
  fill_fields_below: 'Fyll i fälten nedan',
  IMPORT_CSV_feature: 'CSV-import',
  no_import_access:
    'Uppgradera din plan för att importera från CSV- och Excel-filer',
  members: 'Medlemmar',
  assign_user: 'Tilldela användare',
  assign_asset: 'Tilldela tillgång',
  required_files_on_completion: 'Filer krävs vid slutförande av arbetsorder',
  required_tasks_on_completion: 'Uppgifter måste slutföras',
  required_labor_on_completion: 'Du måste logga tid',
  required_part_on_completion: 'Ingen del har använts i denna arbetsorder',
  required_cost_on_completion:
    'Ingen kostnadsinformation finns i denna arbetsorder',
  estimated_hours_in_text: '{{hours}} uppskattade timmar',
  required_part_name: 'Delnamn krävs',
  asset_update_failure: 'Det gick inte att redigera tillgången',
  terms_of_service: 'Användarvillkor',
  privacy_policy: 'Integritetspolicy',
  last_login: 'Senaste inloggning',
  not_enough_part: 'Det finns inte tillräckligt av den här delen',
  remove_blank_meter_tasks: 'Ta bort uppgifter med typen mätare utan mätare',
  checklist_update_failure: 'Checklistan kunde inte redigeras',
  contact_us: 'Kontakta oss',
  simplify_wo: 'Förenkla arbetsordrar i mobilappen',
  simplify_wo_description:
    'Dölj tidskontroller, kostnader och artiklar i arbetsorderinformationen när du använder mobilappen',
  account_deletion: 'Borttagning av konto på {{brandName}}',
  switch_account: 'Byt konto',
  switch_to_super_user: 'Byt till superadministratör',
  switch_account_description: 'Välj ett konto för att fortsätta',
  put_location_in_map: 'Lägg plats på kartan',
  confirm_disable_user:
    'Är du säker på att du vill inaktivera {{user}}? Du kommer bara att kunna aktivera det efter en månad.',
  user_disabled_success: 'Användaren har inaktiverats',
  disable: 'Inaktivera',
  manufacturer: 'Tillverkare',
  power: 'Driva',
  import_error: 'Importen misslyckades',
  request_upgrade: 'Begär uppgradering',
  operation_success: 'Operationen är en succé',
  CANCELLED: 'Avvisad',
  uptime_hours: 'Drifttid (h)',
  downtime_hours: 'Stilleståndstid (h)',
  mark_all_as_seen: 'Markera alla som sett',
  estimation_accuracy_ratio: 'Uppskattningsnoggrannhetsförhållande',
  download_template: 'Ladda ner mall',
  pareto_by_total_price: 'Pareto efter totalpris',
  cumulative_percent: 'Kumulativ procentandel',
  part_consumption_by_asset: 'Delförbrukning per tillgång',
  grouped_by_wo_category: 'Grupperad efter arbetsorderkategori',
  resolution_rate: 'Upplösningsfrekvens',
  resolved: 'Löst',
  average: 'Genomsnitt',
  documentation: 'Dokumentation',
  days_before_pm_notification:
    'Aviseringar om förhandsorder för schemalagda ordrar',
  estimated_start_date: 'Förväntat startdatum',
  no_file_linked_to_wo: 'Ingen fil bifogad till denna arbetsorder',
  add_file: 'Lägg till fil',
  try_for_free: 'Prova gratis',
  choose_your_plan: 'Välj din plan',
  STARTER_description:
    'Team som vill bygga effektivt och starkt förebyggande underhåll genom att se över maskinens status och personalstyrka.',
  PROFESSIONAL_description:
    'Avdelningar som behöver utnyttja insikter och analyser för att driva ytterligare tillväxt och produktivitet inom underhåll.',
  BUSINESS_description:
    'Organisationer redo att samla in underhålls- och driftsdata för att hantera flera platser och systemanpassning.',
  book_demo: 'Boka en demo',
  request_pricing: 'Begär prisuppgifter för mer information',
  Reports: 'Rapporter',
  'Custom dashboard built using the included components':
    'Anpassad instrumentpanel byggd med de medföljande komponenterna',
  Export: 'Exportera',
  'Last year': 'Förra året',
  Expenses: 'Utgifter',
  Statistics: 'Statistik',
  General: 'Allmän',
  Calendar: 'Kalender',
  Mailbox: 'Brevlåda',
  Dashboards: 'Instrumentpaneler',
  Analytics: 'Analys',
  Monitoring: 'Övervakning',
  Tasks: 'Uppgifter',
  Applications: 'Applikationer',
  Users: 'Användare',
  'List All': 'Lista alla',
  'User Profile': 'Användarprofil',
  Login: 'Inloggning',
  Register: 'Register',
  'Recover Password': 'Återställ lösenord',
  Status: 'Status',
  'Error 404': 'Fel 404',
  'Error 500': 'Fel 500',
  'Coming Soon': 'Kommer snart',
  Maintenance: 'Underhåll',
  Overview: 'Översikt',
  Documentation: 'Dokumentation',
  Welcome: 'Välkomna',
  Help: 'Hjälp',
  'Features tour': 'Funktionsvisning',
  'Getting started guide': 'Komma igång-guide',
  'Contact support': 'Kontakta supporten',
  Version: 'Version',
  Search: 'Söka',
  Notifications: 'Aviseringar',
  Settings: 'Inställningar',
  'Language Switcher': 'Språkväxlare',
  'Sign out': 'Logga ut',
  'Change Theme': 'Ändra tema',
  'View all notifications': 'Visa alla aviseringar',
  rate: 'hastighet',
  select_at_least_column: 'Välj minst en kolumn',
  already_read: 'Redan läst',
  OPERATIONAL: 'Operativ',
  DOWN: 'Ner',
  MODERNIZATION: 'Modernisering',
  STANDBY: 'Standby',
  INSPECTION_SCHEDULED: 'Inspektion planerad',
  COMMISSIONING: 'Idrifttagning',
  EMERGENCY_SHUTDOWN: 'Nödavstängning',
  select_asset_status: 'Välj tillgångsstatus',
  asset_status: 'Tillgångsstatus',
  ui_configuration: 'UI-konfiguration',
  password_leave_empty_if_you_dont_want_to_change:
    'Lösenord - lämna tomt om du inte vill ändra det',
  upgrade_request_success:
    'Uppgraderingsbegäran mottagen! Vi kontaktar dig snart med betalningsuppgifter.',
  continue_with_sso: 'Fortsätt med SSO',
  see_live_demo: 'Se live-demo'
};

export default locale;
